import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import "../css/mainhome.css";
import "../css/OpenGame.css"; // Reuse standardized card styles
import apiClient from "../api/apiClient";
import AppHeader from "../components/AppHeader";

const JackpotGames = () => {
  const navigate = useNavigate();
  const { marketId } = useParams();
  const location = useLocation();
  const { user } = useContext(AppContext);

  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const marketName = location.state?.gameName || "Jackpot Game";
  const walletBalance = localStorage.getItem("walletBalance");

  useEffect(() => {
    const fetchJackpotGameTypes = async () => {
      const mobileNo = user?.mobileNo || localStorage.getItem("mobileNo");
      if (!mobileNo) {
        setError("Mobile number not found.");
        setLoading(false);
        return;
      }

      try {
        const response = await apiClient.get("/jackpot-game-bid-type");

        if (response.data?.status && Array.isArray(response.data.info)) {
          setGames(response.data.info);
        } else {
          throw new Error(response.data.msg || "Failed to fetch game types.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchJackpotGameTypes();
  }, [user]);

  const handleGameClick = (game) => {
    navigate(`/bid/jackpot/${marketId}/${game.type}`, {
      state: { marketName },
    });
  };

  return (
    <div className="mainhome-screen-wrapper">
      <AppHeader
        title={marketName}
        walletBalance={walletBalance}
        onBack={() => navigate(-1)}
        onWalletClick={() => navigate("/passbook")}
      />

      <div
        className="open-game-container"
        style={{
          flex: 1,
          overflowY: "auto",
          paddingBottom: "100px",
          scrollbarWidth: "none",
        }}
      >
        <div className="game-grid">
          {loading && <p style={{ textAlign: "center", width: "100%" }}>Loading Games...</p>}
          {error && <p style={{ textAlign: "center", width: "100%", color: "red" }}>{error}</p>}

          {!loading &&
            !error &&
            games.map((game) => (
              <div
                key={game.id}
                className="game-carrd"
                onClick={() => handleGameClick(game)}
                role="button"
              >
                <div className="icon-wrapper">
                  <img src={game.image} alt={game.name} />
                </div>
                <p>{game.name}</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default JackpotGames;